import { useQuery } from "@tanstack/react-query";
import {
  type TransactionStatus,
  getTransactionsSum,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  startDate: Date;
  endDate: Date;
  allowedStatuses: Array<TransactionStatus>;
  variant: "incoming" | "outgoing";
};

export const useTransactionsSum = ({
  startDate,
  endDate,
  allowedStatuses,
  variant,
}: Props) =>
  useQuery({
    queryKey: [
      "TRANSACTIONS_SUM",
      { startDate, endDate, allowedStatuses, variant },
    ],
    queryFn: processResponseWithApiProblemDetails(() =>
      getTransactionsSum(
        startDate.toISOString(),
        endDate.toISOString(),
        allowedStatuses,
        variant === "incoming",
      ),
    ),
    refetchInterval: 30_000,
  });
